import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Typography, Box } from '@mui/material';

const PitchesPerInningChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ height: 250, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="body2" color="text.secondary">No Data</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: 250 }}>
      <ResponsiveContainer>
        <BarChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 25,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="inning" label={{ value: 'Inning', position: 'insideBottom', offset: -5 }} padding={{ bottom: 20 }} />
          <YAxis label={{ value: 'Pitches', angle: -90, position: 'insideLeft' }} />
          <Tooltip />
          <Bar dataKey="pitches" fill="#1976d2" isAnimationActive={false} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default PitchesPerInningChart;

